import { store } from "index";
import dummyProfile from './../assets/images/svg/crypto-icons/profile-circle.svg'
import dummyProfile2 from './../assets/images/dummyProfile.png'
import uploadcover from './../assets/images/uploadPlacehoder.png'
import apiUrl, { localPath } from "slices/apiEndpoint";
import axios from "axios";
import { toast } from "react-toastify";
import api from "./api";
// Color schema
export const primaryColor = "#1f57d6";
export const grayColor = "#d9dfdb";
export const orangeColor = "#e96904";
export const blueColor2 = "#0091e7";
export const deepBlue = "#18202a";

export const profileURL = ()=>{
    const userProfile = store.getState().UserProfile.user as any
   return userProfile.length && userProfile[0].ua_profile_pic != null
    ? userProfile[0].ua_profile_pic
    : dummyProfile

}
export const CallAPIGetPromise = (path:string) => {
  const token = store.getState().Login.token
    return new Promise((resolve, reject) => {
      try {
        api
          .get(`${path}`, {
            headers: {
              "Content-Type": "application/json",
            }
          })
          .then((t) => {
            resolve(t);
          })
          .catch((error) => {
            // dispatch(setSpinnerLoading(false));
            console.log(error);
            reject(error);
  
           
          });
      } catch {
        reject("Try Catch");
      }
    });
  };
  export const CallAPITESTGetPromise = (path:string) => {
    const token = store.getState().Login.token
      return new Promise((resolve, reject) => {
        try {
          axios
            .get(`${localPath}${path}`, {
              headers: {
                "Content-Type": "application/json",
                Authorization:`Bearer ${token}` ,
              }
            })
            .then((t) => {
              resolve(t);
            })
            .catch((error) => {
              // dispatch(setSpinnerLoading(false));
              console.log(error);
              reject(error);
    
            
            });
        } catch {
          reject("Try Catch");
        }
      });
    };
export const CallAPIPostPromise = (path:string, data:any) => {
  
  const token = store.getState().Login.token
    return new Promise((resolve, reject) => {
      try {
        api
          .post(`${path}`, data, {
            headers: {
              "Content-Type": "application/json",
            }
          })
          .then((t) => {
            resolve(t);
          })
          .catch((error:any) => {
            const responseData = error?.response?.data;
            const normalizedError = {
              ...(responseData && typeof responseData === "object" ? responseData : {}),
              status: error?.response?.status || 0,
              message:
                responseData?.message ||
                error?.message ||
                "Network error or server not reachable",
              reason: responseData?.reason || "",
              paymentProvider: responseData?.paymentProvider || "",
              response: error?.response,
            };

            reject(normalizedError);
          });
      } catch {
        reject("Try Catch");
      }
    });
  };
export const CallAPIPutPromise = (path:string, data:any) => {
  return new Promise((resolve, reject) => {
    try {
      api
        .put(`${path}`, data, {
          headers: {
            "Content-Type": "application/json",
          }
        })
        .then((t) => {
          resolve(t);
        })
        .catch((error:any) => {
          reject(error);
        });
    } catch {
      reject("Try Catch");
    }
  });
};
  export const CallAPIDeletePromise = (path:string) => {
    const token = store.getState().Login.token
      return new Promise((resolve, reject) => {
        try {
          api
            .delete(`${path}`, {
              headers: {
                "Content-Type": "application/json",
              }
            })
            .then((t) => {
              resolve(t);
            })
            .catch((error) => {
              // dispatch(setSpinnerLoading(false));
              console.log(error);
              reject(error);
    
              if (error.response.data.name === "TokenExpiredError") {
                // dispatch(setSessionExpired(true));
              } else {
               
              }
            });
        } catch {
          reject("Try Catch");
        }
      });
    };


  export const CallAPIPostPromiseTEST = (path:string, data:any) => {
  
    const token = store.getState().Login.token
      return new Promise((resolve, reject) => {
        try {
          axios
            .post(`${localPath}${path}`, data, {
              headers: {
                "Content-Type": "application/json",
                Authorization:`Bearer ${token}` ,
              }
            })
            .then((t) => {
              resolve(t);
            })
            .catch((error:any) => {
              // dispatch(setSpinnerLoading(false));
               // Reject full response body for frontend to read
               reject(error);
          if (error?.response) {
            const { data, status } = error.response;
            // Optional: handle token expiration
            if (data?.error?.name === "TokenExpiredError") {
              console.warn('🔒 Token expired:', data.error.name);
            }
  
         
          } else {
            // Network or unexpected error
            reject({
              status: 0,
              message: 'Network error or server not reachable',
              details: error.message || error,
            });
          }
            });
        } catch {
          reject("Try Catch");
        }
      });
    };
export const dummyProfileImage = dummyProfile2
export const uploadPlaceholderCover = uploadcover
